<template>
  <Footer
    :mode="mode"
    :contents="contents"
  >
    <template v-if="isShowSocialMedia" v-slot:iconTop>
      <NuxtLink to="https://twitter.com/ka_nabell_pcg" aria-label="Company X Account" target="_brank">
        <XIcon />
      </NuxtLink>
      <NuxtLink to="https://lin.ee/V6nGtev" aria-label="Company LINE Account" target="_brank">
        <Line />
      </NuxtLink>
    </template>
  </Footer>
</template>

<script lang="ts">
import { defineNuxtComponent, useRouter } from '#imports'
import { computed } from 'vue'
import { Footer } from '@ka-nabellinc/ka-nabell-ui'
import { type Content, guides, cardGenreList, shopSeries } from './const'
import { useProfileWeb } from '@/composables/useProfileWeb'
import { Line, XIcon } from '@ka-nabellinc/ka-nabell-icons'

export default defineNuxtComponent({
  components: {
    Footer,
    Line,
    XIcon,
  },
  async setup() {
    const router = useRouter()
    const isShowShopSeries = computed(() => router.currentRoute.value.meta.footer?.isShowShopSeries)
    const isShowSocialMedia = computed(() => router.currentRoute.value.meta.footer?.isShowSocialMedia)
    const isLp = computed(() => router.currentRoute.value.path.split('/').includes('lp'))
    const isTopPage = computed(() => router.currentRoute.value.path === '/')
    // TODO: 2024/11/20現在、対応しているカード種がポケモンのみなので、暫定的にデフォルトの mode を pm とする
    const mode = computed(() => isTopPage.value ? 'default' : 'pm')

    const {
      externalTransmissionLink,
      privacyPolicyLink,
      specifiedCommercialTransactionsActLink,
      termsOfServiceLink,
     } = useProfileWeb()

    const getCompanyInfo = (): Content => ({
      headline: '会社情報',
      items: [
        {
          text: '会社概要（運営会社）',
          link: 'https://about.ka-nabell.com/',
          isExternal: true,
        },
        {
          text: '採用情報',
          link: 'https://party.tcg-revo.com/',
          isExternal: true,
        },
        {
          text: '利用規約',
          link: termsOfServiceLink.value,
        },
        {
          text: 'プライバシーポリシー',
          link: privacyPolicyLink.value,
        },
        {
          text: '特定商取引法に基づく表記',
          link: specifiedCommercialTransactionsActLink.value,
        },
        {
          text: '情報の外部送信について',
          link: externalTransmissionLink.value,
        },
      ]
    })

    const contents = computed<Content[]>(() => {
      let contents: Content[] = []
      if (isLp.value) return contents

      // ご利用ガイド
      contents.push(guides)
      // 販売中のポケカシリーズ
      if (isShowShopSeries.value) {
        contents.push(shopSeries)
      }
      // カード種別一覧
      contents.push(cardGenreList)
      // 会社情報
      contents.push(getCompanyInfo())

      return contents
    })

    return {
      mode,
      isTopPage,
      contents,
      isShowSocialMedia,
    }
  }
})
</script>

<style scoped>
</style>
